<script setup lang="ts">
import SupportLinks from '@/components/session/kyc/supportLinks/SupportLinks.vue';

const props = defineProps<{
  unsupportedDocument?: boolean;
}>();

const title = props.unsupportedDocument
  ? 'Unsupported Document Type'
  : 'Document Verification Issue';
const mainText = props.unsupportedDocument
  ? "We currently don't support the identification document you submitted. Please try again with an accepted document type."
  : "We're sorry, but we encountered a problem while trying to verify your documents. Please try again.";
</script>

<template>
  <h1 class="mb-4 text-3xl">{{ title }}</h1>
  <div data-test="base-content-layout-description">
    <div class="text-light-secondary dark:text-dark-secondary mb-6">
      <p>{{ mainText }}</p>
      <br />
      <SupportLinks issue="idv-error" v-if="!unsupportedDocument" />
    </div>
  </div>
</template>
